import { useStore } from "app/context"
import { DatenStandModel } from "app/stores/datenstand.store";
import { observer } from "mobx-react"
import { useEffect } from "react";
import { ITableColumn, TableModel } from "./table/table.model";
import { Table } from "./table/table";
import { DottedTag } from "./common/DottedTag";
import { AdminImportNewButton } from "./admin/imports/AdminImportNewButton";
import { formatNum } from "app/utils";

interface DatenStandListProps {
    searchFilter: string;
    groupFilter: 'all' | 'core' | 'project' | 'adz';
}

export const DatenStandList = observer(({ searchFilter, groupFilter }: DatenStandListProps) => {

    const { adminDatenStandStore: datenStandStore } = useStore();
    const tm = new TableModel<DatenStandModel, string>();
    const cols: ITableColumn<DatenStandModel, string>[] = [
        {
            label: 'Alter (Tage)',
            path: 'ageInDays',
            sortBy: 'ageForSorting',
            render: (row) => {
                return <> {row.data.ageInDays !== -500 &&
                    <DottedTag color={row.data.color} text={row.data.ageInDays.toString()} />
                } </>

            }
        },
        // {
        //     label: 'Alter (Tage)',
        //     path: 'ageForSorting',

        // },
        {
            label: 'Neuer Job',
            path: 'importDataType',
            render: (row) => {
                return <AdminImportNewButton path={row.data.importDataType} title={row.data.importDataType} />
            }
        },
        {
            label: 'Datenstand',
            path: 'standFormated',
        },
        {
            label: '.. für',
            path: 'dataType',
        },


        {
            label: 'Turnus',
            path: 'cycle',
        },
        {
            label: 'Scope:Lieferung',
            path: 'incominDataTimeScope',
        },
        {
            label: 'Scope:DVS',
            path: 'dvsTimeScope',
        },
        {
            label: 'Anzahl Agts',
            path: 'agtCount',
            format: formatNum
        },
        {
            label: 'Anzahl Zeilen',
            path: 'rowCount',
            format: formatNum
        },
        // {
        //     label: 'dbTarget',
        //     path: 'dbTarget',
        // },
        // {
        //     label: 'timeSelection',
        //     path: 'timeSelection',
        // },
        // {
        //     label: 'apFachlich.name',
        //     path: 'apFachlich.name',
        // },
        // {
        //     label: 'apTechnisch.name',
        //     path: 'apTechnisch.name',
        // },

    ];

    tm.setCols(cols);
    tm.sortBy = 'ageForSorting';
    tm.sortAsc = false;
    tm.idProperty = 'dataType';
    tm.idType = 'string';

    useEffect(() => {
        datenStandStore.findAll().then(res => {
            let filtered = res;
            if (groupFilter !== 'all') {
                filtered = filtered.filter(item => item.group?.includes(groupFilter));
            }
            if (searchFilter) {
                filtered = filtered.filter(item => item.toSearchString.includes(searchFilter.toLowerCase()));
            }
            tm.setRowData(filtered);
        });
    }, [datenStandStore, searchFilter, groupFilter])

    return <>
        <Table tm={tm} />
    </>
})

